<template lang="pug">
Overlay(
    title="Order Status"
    @close="close"
    uniqueKey="orderlogin"
    modalSize="small"
    :enableDarkMode="true"
)
    baseForm(@submit='orderLogin' id="orderStatusForm")
        div(slot="error" v-if="errors" class="text-center text-sm text-white bg-danger rounded py-3 px-1 mb-3") {{ errors }}
        baseInput(
            ref="orderNumber"
            label='Order Number',
            type="text"
            name="orderNumber"
            :isRequired='true',
            default-error-text='Please enter an order number',
            v-model='formData.orderNumber'
        )
        email(
            type='email',
            label='Billing Email',
            name='email',
            :isRequired='true',
            default-error-text='Please enter a valid email',
            v-model='formData.email'
        )
    div(class="text-xs text-center text") Enter your order number and billing email address to see the status of your order.
        template(v-if="$sitewideData.config.returnsUrl?.cached_url") &nbsp;For FAQs and returns, see our #[nuxt-link(:to="{ path: $sitewideData.config.returnsUrl.cached_url }") Return Policy]
    template(#footer)
        BaseButton(
            form="orderStatusForm"
            type='submit'
            :isWaiting="loading"
            class="w-full"
        ) Check Status
        template(v-if="hasExtraButton")
            div(class="mt-4 text-lg font-bold text-black") {{ $sitewideData.config.extraButtonHeading}}
            BaseButton(
                type='button'
                buttonStyle="OUTLINE"
                color="BLACK"
                class="w-full mt-4"
                :to="$sitewideData.config.extraButtonLink.cached_url"
            ) {{ $sitewideData.config.extraButtonText }}
</template>

<script>
import formMixin from '@/components/form/mixin'
import BaseButton from '@/components/baseButton'
const Overlay = () => import(/* webpackChunkName: "overlay" */ '@/components/overlay')

export default {
    components: {
        BaseButton,
        Overlay,
    },
    mixins: [formMixin],
    data() {
        return {
            formData: {
                orderNumber: '',
                email: '',
            },
            errors: null,
            loading: false,
        }
    },
    computed: {
        hasExtraButton() {
            return this.$sitewideData.config.extraButtonLink?.cached_url
        },
    },
    methods: {
        close() {
            this.$overlay.hide()
        },
        orderLogin() {
            if (this.errors) this.errors = null
            this.loading = true
            this.$store
                .dispatch('orders/orderLogin', this.formData)
                .then((response) => {
                    this.$push.to({
                        name: 'order-status',
                        params: { orderId: response.data.id },
                        query: { token: response.data.token },
                    })
                })
                .catch(() => {
                    this.loading = false
                    this.errors =
                        'Sorry, we could not find your order. Please check your Order Number and Email.'
                })
        },
    },
}
</script>
